import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { ANALYTICS_CHANNEL } from './index';
import {
	type AccountSetupAnalyticsEventPayload,
	EVENT_TYPE,
	type FireAnalyticsEvent,
} from './types';

/**
 * A convenient way to fire analytics event of any specific event type for functional component.
 * useFireAnalyticsEvent hook returns an object with four helper function to fire each type of analytic event.
 * @returns FireAnalyticsEvent
 */
export const useFireAnalyticsEvent = (source?: string): FireAnalyticsEvent => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireAnalyticEvent =
		(eventType: EVENT_TYPE) => (payload: AccountSetupAnalyticsEventPayload) => {
			const analyticsEvent = createAnalyticsEvent({
				...payload,
				eventType,
				source,
			});
			analyticsEvent.fire(ANALYTICS_CHANNEL);
		};

	return {
		fireUIAnalyticEvent: fireAnalyticEvent(EVENT_TYPE.UI),
		fireTrackAnalyticEvent: fireAnalyticEvent(EVENT_TYPE.TRACK),
		fireOperationalAnalyticEvent: fireAnalyticEvent(EVENT_TYPE.OPERATIONAL),
		fireScreenAnalyticEvent: fireAnalyticEvent(EVENT_TYPE.SCREEN),
	};
};
